// tinymce library is loaded through a script tag
/* global tinymce */
import cssUrl from '../../sass/app.scss?url';

$(function () {
    // Edit the attached to
    function toggleChevron(e) {
        $(e.target)
            .prev('.card-header')
            .find('span.indicator')
            .toggleClass('fa-plus fa-minus');
    }

    $('#accordion').on('hidden.bs.collapse', toggleChevron);
    $('#accordion').on('shown.bs.collapse', toggleChevron);

    $(document).on('click', '.delete-faq-item', function(ev){
        ev.preventDefault();
        var form = $(this).parent('form');
        if (confirm("Are you sure?")) {
            form.submit();
        }

    });

    if ($('.tinymce').length > 0) {

        var tinymcePlugins = [];

        tinymcePlugins.push(

            function (ed) {
                ed.ui.registry.addButton('quote', {
                    title: 'Add Quote',
                    tooltip: 'Add Quote',
                    icon: 'quote',
                    onAction: function () {
                        // Add you own code to execute something on click
                        ed.windowManager.open({
                            title: 'Quote',
                            size: 'small',
                            body: {
                                type: 'panel',
                                items: [
                                    {type: 'input', name: 'quote', label: 'Quote'}
                                ]
                            },
                            buttons: [
                                {type: 'submit', name: 'submitButton', text: 'OK', buttonType: 'primary'},
                                {type: 'cancel', name: 'closeButton', text: 'Cancel'},
                            ],
                            onSubmit: (dialogApi) => {
                                const data = dialogApi.getData();
                                if (data.quote === '') {
                                    alert ('Please fill in a quote');
                                    return false;
                                }
                                // Insert content when the window form is submitted
                                ed.insertContent('<div class="alert alert-info"><span class="fa fa-location-arrow"></span>' + data.quote + '</div>');
                                dialogApi.close();
                            }
                        });
                    }
                });

                ed.ui.registry.addButton('highlight', {
                    title: 'Add text with Icon block',
                    tooltip: 'Add text with Icon block',
                    icon: 'highlight-bg-color',
                    onAction: function () {
                        // Add you own code to execute something on click
                        ed.windowManager.open({
                            title: 'Add text with Icon block',
                            size: 'small',
                            body: {
                                type: 'panel',
                                items: [
                                    {type: 'input', name: 'title', label: 'Title', multiline: false},
                                    {type: 'input', name: 'icon', label: 'Fontawesome Icon', multiline: false},
                                    {type: 'input', name: 'content', label: 'Content', multiline: true}
                                ]
                            },
                            buttons: [
                                {type: 'submit', name: 'submitButton', text: 'OK', buttonType: 'primary'},
                                {type: 'cancel', name: 'closeButton', text: 'Cancel'},
                            ],
                            onSubmit: (dialogApi) => {
                                const data = dialogApi.getData();
                                if (data.title === '' || data.content === '') {
                                    alert ('Please fill in title and content');
                                    return false;
                                }
                                ed.insertContent('<div class="highlight"><span class="fa ' + data.icon + '"></span><h2>' + data.title + '</h2>' + data.content + '</div>');
                                dialogApi.close();
                            }
                        });
                    }
                });

            });

        tinymce.init({
            selector: '.tinymce',
            height: 500,
            menubar: false,
            branding: false,
            plugins: 'preview code fullscreen image link media anchor',
            toolbar: 'formatselect | bold italic | link image | alignleft aligncenter alignright alignjustify  | quote highlight | numlist bullist | removeformat code',
            block_formats: 'Paragraph=p;Header 2=h2;Header 3=h3;',
            style_formats: [
                { title:"Heading 2", block:"h2" },
                { title:"Heading 3", block:"h3" },
                { title:"Paragraph", block:"p" }
            ],
            extended_valid_elements: 'span[class]',
            content_css: cssUrl,
            setup: function (ed) {
                tinymcePlugins.forEach(function(callback) {
                    if (typeof callback === "function") {
                        callback(ed);
                    }
                });

                // Keep content input element in sync when changing
                ed.on('change', function () {
                    ed.save();
                });
            }
        });



    }

});
